import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid, GridToolbarContainer, GridToolbarQuickFilter, GridToolbarExportContainer, GridCsvExportMenuItem } from '@mui/x-data-grid';
import { useEffect } from 'react';
import { Button, Checkbox, FormControlLabel, FormGroup, Tooltip } from '@mui/material';
import { useSnackbar } from 'notistack';
import { handleValidateCodevalue } from '../Utility/constant';
import AddIcon from '@mui/icons-material/Add';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import LeadDialog from './LeadDialog';
import { requestHideLoader, requestShowLoader } from '../Store/Global/action';
function CustomToolbar(props) {
  
  const {isDashboard,handleMarkAsRead,showFilter, columnVisibilityModel1,setColumnVisibilityModel, columns,specificRolePermission, internationalise , setIsOpenDialog ,isInvoiceScreen, isOrderScreen, quickFilterProps , isViewMode, handleDeleteProduct, clientId, handleLaunchcampaign, handleAddCode, isUserScreen, handleNotifyCustomer, isCustomerscreen,  orderstatus, handleNotifyUser, isOrderproduct, selectionModel, isRequiredToolBar, handlegenerateinvoice, gridType, filename, handleAddClick } = props;
const dispatch = useDispatch()
const [checkedColumns, setCheckedColumns] = React.useState({});
  const [open , setOpen] = React.useState(false)

useEffect(() => {
  setColumnVisibilityModel(prevModel => {
    if (prevModel && Object.keys(prevModel).length > 0) {
      return prevModel;
    }
    return Object.fromEntries(columns.map(col => [col.field,true])
    );
  });
}, [columns, setColumnVisibilityModel]);

  const handleCheckboxChange = (field) => {
    setCheckedColumns(prev => ({
      ...prev,
      [field]: !prev[field],
    }));
  };
  
  const handleSave=()=>{
    dispatch(requestShowLoader())
    setColumnVisibilityModel({
    ...checkedColumns
  })
  setOpen(false)
    dispatch(requestHideLoader())
  }
  const handleOpenFilter = () => {
  setOpen(true);

  setCheckedColumns(prev => {
    const updated = {};
    Object.entries(columnVisibilityModel1).forEach(([key, value]) => {
      if (value) {
        updated[key] = true;
      } else {
        updated[key] = false;
      }
    });
    return updated;
  });
};

  if(isRequiredToolBar) {
  return (
    <GridToolbarContainer style={{display: 'flex', justifyContent: 'space-between'}}>
     {showFilter &&
      <Box sx = {{width:"50%",display: 'flex', alignItems:"center"}}>
        <Box sx = {{width:"35%"}}>
   <Tooltip title={handleValidateCodevalue(internationalise,"COMMON_SHOW_COLUMNS")}>
  <Button sx = {{width:"100%"}} onClick={() => handleOpenFilter()}>
    {handleValidateCodevalue(internationalise,"COMMON_SHOW_COLUMNS")}
  </Button>
</Tooltip>
    </Box>
    </Box>
  }
      <LeadDialog
      open = {open}
      handleClose={()=>setOpen(false)}
      handleSave={handleSave}
      title={handleValidateCodevalue(internationalise,"COMMON_SHOW_COLUMNS")}
      btnlabel = {handleValidateCodevalue(internationalise,"COMMON_SAVE")}
      >
      <FormGroup>
        <FormControlLabel sx = {{borderBottom : "2px solid #D9DDDC"}}
    control={
      <Checkbox
        checked={Object.values(checkedColumns).every(Boolean)} // all true
        indeterminate={
          !Object.values(checkedColumns).every(Boolean) &&
          Object.values(checkedColumns).some(Boolean) // partial selection
        }
        onChange={(e) => {
          const checked = e.target.checked;
          // set all columns to same value (true/false)
          const updated = Object.fromEntries(
            columns
              .filter(col => col.field !== "actions" && col.field !== "followup") // ⛔ exclude these
              .map(col => [col.field, checked])
          );
          setCheckedColumns(updated);
        }}
      />
    }
    label={handleValidateCodevalue(internationalise,"COMMON_SELECT_ALL")}
  />
      {columns
    .filter(col => col.field !== "actions" && col.field !== "followup") // ⛔ exclude before mapping
    .map((item) => (
        <FormControlLabel
          key={item.field}
          control={
            <Checkbox
              checked={!!checkedColumns[item.field]}
              onChange={() => handleCheckboxChange(item.field)}
              
            />
          }
          label={item.headerName}
        />
      ))}
    </FormGroup>
    </LeadDialog>
    <Box sx = {{display:'flex',justifyContent:'flex-end',alignItems:'center'}}>
   <GridToolbarExportContainer>
        <GridCsvExportMenuItem
          options={{
            fileName: `${filename}_${moment(new Date()).format()}`,
            delimiter: ';',
            utf8WithBom: true,
          }}
        />
      </GridToolbarExportContainer>
      <div>
        {(isOrderproduct && !isViewMode) && <Button color="primary" onClick={handlegenerateinvoice} disabled={!(selectionModel?.length > 0)} style={{margin: '0 10px'}}>
           {handleValidateCodevalue(internationalise,'TA_GEN_INV')}
        </Button>
        }
        {((isOrderScreen && (specificRolePermission?.isAllOrderManage || specificRolePermission?.isOrderTeamManage)) || (isInvoiceScreen && (specificRolePermission?.isAllInvoiceManage || specificRolePermission?.isInvoiceTeamManage))) && 
          <Button color="primary" onClick={()=>setIsOpenDialog(true)} disabled={!(selectionModel.length > 0)} style={{margin: '0 10px'}}>
            {isOrderScreen ? handleValidateCodevalue(internationalise,'TA_SO_RE_ASSIGN') : handleValidateCodevalue(internationalise,'TA_INV_RE_ASSIGN')}
          </Button>
        }
        {(gridType == "Internationalise" && process.env.REACT_APP_DEFAULT_CLIENT ==  clientId)&& (
          <Button style={{margin: '0 10px'}} color="primary" startIcon={<AddIcon />} onClick={handleAddCode}>
            {handleValidateCodevalue(internationalise,'TA_ADD_CODE')}
        </Button>
        )}

        {(gridType == 'systemlookup' || gridType == "clientlookup") && (
           <Button style={{margin: '0 10px'}} color="primary" startIcon={<AddIcon />} onClick={handleAddClick}>
            {gridType == 'systemlookup' ? handleValidateCodevalue(internationalise,'TA_ADD_SLC') : handleValidateCodevalue(internationalise,'TA_ADD_CLIENT_LU')}
          </Button>
        )}
        {(gridType == 'accountuser' && !isUserScreen) && (
          <Button color="primary" onClick={handleNotifyUser} disabled={!(selectionModel?.length > 0)} style={{margin: '0 10px'}}>
            {handleValidateCodevalue(internationalise,'TA_NOTI_SELECTED_USER')}
          </Button>
        )}
      
      {gridType == 'campaign' && (
          <Button color="primary" onClick={handleLaunchcampaign} disabled={!(selectionModel?.length == 1)} style={{margin: '0 10px'}}>
              {handleValidateCodevalue(internationalise,'TA_LAUNCH_PROD_CAMPAIGN')}
          </Button>
        )}
       {gridType == "customer" && (
        <Button color="primary" onClick={handleNotifyCustomer} disabled={!(selectionModel?.length > 0)} style={{margin: '0 10px'}}>
            {handleValidateCodevalue(internationalise,'TA_NOTI_SELECTED_CUST')}
        </Button>
       )}
       {isDashboard&& (
        <Button color="primary" onClick={handleMarkAsRead} disabled={!(selectionModel?.length > 0)} style={{margin: '0 10px'}}>
            {handleValidateCodevalue(internationalise,'MARK_AS_READ')}
        </Button>
       )}
      </div>
      <GridToolbarQuickFilter {...quickFilterProps} />
      </Box>
    </GridToolbarContainer>
  );
      } else {
        return null;
      }
}

export default function DataGridTable({isDashboard = false,handleMarkAsRead, getRowClassName,showFilter=true,onCellClick,hideFooter=false,handleProcessRowUpdate,setIsOpenDialog , marginTop= "20px", isInvoiceScreen, isOrderScreen , isLoading = false, isViewMode, clientId, handleAddCode, height = "calc(100vh - 221px)", handleAddClick, isUserScreen = true, handleNotifyCustomer, isCustomerscreen = true, handleNotifyUser, handleLaunchcampaign, isRowSelectable = true, isInvoiceproduct = false,  orderstatus, handlegenerateinvoice, isOrderproduct = false,filename="", columnVisibilityModel = {invoicedqty: false, viewinvoice: false}, selectionModel, gridType="", setSelectionModel, isCheckboxReq = true, isRequiredToolBar = true , dataGridData = [], columns, rowModesModel, handleUpdateProduct, handleDeleteProduct}) {
  const [columnVisibilityModel1,setColumnVisibilityModel] = React.useState(isRequiredToolBar ? {} : columnVisibilityModel)
  const [rows, setRows] = React.useState([]);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
  const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
  useEffect(() => {
    setRows(dataGridData)
  },[dataGridData])

  const handleRowEditStart = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const handleRowEditStop = (params, event) => {
    event.defaultMuiPrevented = true;
  };

  const processRowUpdate = async(newRow, oldRow) => {
    if(JSON.stringify(oldRow) === JSON.stringify(newRow)){
      enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_NO_DATA_CHANGED"),{variant:"info"})
      return;
    }
    if(isInvoiceproduct) {
      if(parseInt(newRow?.invoiceqty) > parseInt(oldRow?.remainingQty)) {
        enqueueSnackbar(handleValidateCodevalue(internationalise,`COMMON_INV_QTY_REM_QTY_WARNING`), {variant: 'error'});
        setRows(rows.map((row) => (row.id === newRow.id ? row : row)));
        handleUpdateProduct(oldRow);
        return oldRow;
      } else {
        handleUpdateProduct(newRow); 
        const updatedRow = { ...newRow, isNew: false };
        setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
        return updatedRow;
      }

    } else {
      // if(JSON.stringify(newRow) == JSON.stringify(oldRow)) {
      //   enqueueSnackbar(`No data changed.`, {variant: 'info'});
      // } else {
        await handleUpdateProduct(newRow); 
        const updatedRow = { ...newRow, isNew: false };
        setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));
        return updatedRow;
      // }
      
    }
    
  }; 

  const handleProcessRowUpdateError = React.useCallback(() => {
    
  },[]) 

  const handleEditCellChange = (newValue, rowIndex, columnId) => {
    console.log("newValuerowIndex",rowIndex, newValue, columnId);
  }

  
  return (
    <Box
      sx={{
        height: height,
        overflow: 'auto',
        // marginTop: {marginTop},
        width: '100%',
        '& .actions': {
          color: 'text.secondary',
        },
        '& .textPrimary': {
          color: 'text.primary',
        },
      }}
    >
      <DataGrid
       rowHeight={45}
       disableColumnMenu
      sx={{
      border: 1,                      // overall grid border
      borderColor: 'divider',

      '& .MuiDataGrid-columnHeader': {
      borderRight: '1px solid #CECECE',
      borderLeft: 'none',
    },
      '& .MuiDataGrid-columnHeaders': {
        border: '1px solid #CECECE',
      },
        // Cells styling
        '& .MuiDataGrid-cell:first-child': {
        borderLeft: '1px solid #CECECE',
        borderRight: '1px solid #CECECE', // same for first column cells
        },
        '& .MuiDataGrid-cell:last-child': {
        borderRight: '1px solid #CECECE', // same for last column cells
        },
        '& .MuiDataGrid-cell:not(:first-child):not(:last-child)': {
        borderRight: '1px solid #CECECE',
        },
    }}
      getRowClassName={getRowClassName}
        onCellClick={onCellClick}
        hideFooter = {hideFooter}
        isViewMode = {false}
        rows={rows}
        className='biztantu-datagrid'
        columnVisibilityModel = {columnVisibilityModel1}
        columns={columns}
        editMode="row"
        checkboxSelection = {isCheckboxReq}
        rowModesModel={rowModesModel}
        onRowEditStart={handleRowEditStart}
        onRowEditStop={handleRowEditStop}
        selectionModel={selectionModel}
        onSelectionModelChange={(newSelectionModel) => {
          setSelectionModel(newSelectionModel);
        }}
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        disableSelectionOnClick
        // isRowSelectable={isRowSelectable}
        isRowSelectable={(params) => {
     if (params?.row?.hasOwnProperty('remainingQty')) {
      return (params.row.remainingQty > 0 && !isViewMode );
    }
    if (typeof isRowSelectable === 'function') {
      return isRowSelectable(params);
    }

    // Case 3: If it's a boolean
    return !!isRowSelectable;
        }}
        componentsProps={{
          toolbar: {
            showQuickFilter: rows.length > 0 ? true: false,
            quickFilterProps: { debounceMs: 500, placeholder: handleValidateCodevalue(internationalise,'TA_SEARCH_IN_TABLE') },
            isViewMode,
            isRequiredToolBar, gridType, selectionModel,filename,
            handleDeleteProduct,isOrderproduct, handlegenerateinvoice,
            orderstatus, handleNotifyUser, handleLaunchcampaign,isCustomerscreen,
            handleNotifyCustomer, isUserScreen, handleAddClick, handleAddCode,clientId,
            isOrderScreen , setIsOpenDialog,internationalise,specificRolePermission,isInvoiceScreen,
            columns,columnVisibilityModel1,setColumnVisibilityModel,showFilter,isDashboard,handleMarkAsRead
          },
        }}
        components={{
          Toolbar: CustomToolbar,
        }}
        loading={isLoading}
        processRowUpdate={handleProcessRowUpdate ?? processRowUpdate}
        onEditRowsModelChange={handleEditCellChange}
        experimentalFeatures={{ newEditingApi: true }}
        onProcessRowUpdateError={handleProcessRowUpdateError}
      />
    </Box>
  );
}
